import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { Paragraph, SectionHeading } from './_shared/Prose'

/**
 * Seção 13 (do modelo real) - Plano de Resposta a Emergências. Texto literal do modelo
 * aprovado por Julia Buzzo ("Modelo PGR 2026 - Banco Bradesco_Varejo"). Substitui o
 * placeholder institucional anterior (arquivo era `14.ResponsabilidadesSection.js` — o
 * conteúdo de responsabilidades legais é a Seção 4, ver `04.DireitosEDeveresSection.js`).
 */
const PlanoRespostaEmergenciasSection = () => (
  <View id="13">
    <Separator weight={15} />
    <SectionHeading numero={13}>PLANO DE RESPOSTA A EMERGÊNCIAS</SectionHeading>

    <Paragraph>
      Serão desenvolvidos planos específicos de resposta a emergências, contemplando ações para contenção de eventos
      que possam comprometer a integridade física das pessoas, o meio ambiente e o patrimônio. O plano deverá prever
      protocolos para incêndios, vazamentos, explosões e outras situações críticas, com definição de
      responsabilidades, recursos, fluxos de comunicação e ações de evacuação.
    </Paragraph>

    <Paragraph>
      A Norma Regulamentadora NR-1 estabelece a obrigatoriedade da adoção de ações voltadas à preparação para
      emergências, tendo como premissas fundamentais: a identificação e avaliação dos riscos, prevenção, plano de
      resposta a emergência, treinamentos, conscientização recursos materiais e apoio de órgãos externos. Essas
      diretrizes visam garantir uma resposta eficaz diante de situações emergenciais, protegendo a integridade dos
      trabalhadores e a continuidade das operações.
    </Paragraph>

    <Paragraph>
      A Organização Bradesco por meio da área de Pessoas, Cultura e Performance/Segurança do Trabalho, é responsável
      pela elaboração do Plano de Atendimento de Emergência de suas dependências. Esse plano é desenvolvido com base
      na legislação estadual vigente, quando aplicável. Na ausência de regulamentação específica, adota-se como
      referência a NBR 15219 – Plano de Emergência contra Incêndio, contemplando todos os seus requisitos técnicos.
    </Paragraph>

    <Paragraph>
      A preparação para emergência visa garantir a integridade física dos funcionários e colaboradores, bem como, a
      redução de danos patrimoniais, cumprimento da legislação e promoção de uma cultura de segurança, mantendo um
      ambiente de trabalho seguro e saudável.
    </Paragraph>

    <Separator weight={15} />
  </View>
)

export default PlanoRespostaEmergenciasSection
